module.exports = __webpack_public_path__ + "static/quiz_thumbnail_6-5d2d630c1ae11608c4a84b34276a1d65.jpg";